module.exports = __webpack_public_path__ + "img/b1.da3dab70.png";